// extracted by mini-css-extract-plugin
module.exports = {"container":"SplashScreen_container__1y4Xh","imageContainer":"SplashScreen_imageContainer__3jeKF","title":"SplashScreen_title__2BYRJ"};